var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SuccessScreen',{attrs:{"titleKey":"edit-profile.success.title","messageKey":"edit-profile.success.message","buttonTextKey":"edit-profile.success.button-text"},on:{"accept":_vm.redirectToHome}})
}
var staticRenderFns = []

export { render, staticRenderFns }